import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("token") || "");

  // Small helper to give AUX Pad time to save after we dispatch the event
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  // ✅ Login
  const login = async (username, password) => {
    try {
      const res = await axios.post("https://apihrpay.aiunvrshub.com/api/auth/login", {
        username,
        password,
      });

      setUser(res.data.user);
      setToken(res.data.token);

      localStorage.setItem("user", JSON.stringify(res.data.user));
      localStorage.setItem("token", res.data.token);

      navigate("/home", { replace: true });
    } catch (err) {
      console.error("❌ Login failed:", err.response?.data || err.message);
      throw new Error(err.response?.data?.message || "Invalid username or password.");
    }
  };

  // ✅ Logout (triggers AUX auto-save)
  const logout = async () => {
    try {
      // 1) Tell AUX Pad to save the current session in this tab
      window.dispatchEvent(new Event("auth:logout"));

      // 2) Clear auth (also broadcasts to other tabs via storage event)
      localStorage.removeItem("user");
      localStorage.removeItem("token");

      // Optional: also nuke any cached chat/thread data you keep
      Object.keys(localStorage).forEach((k) => {
        if (k.startsWith("uconnect:chat:")) {
          localStorage.removeItem(k);
        }
      });

      // Update in-memory state
      setUser(null);
      setToken("");

      // 3) Give the AUX saver a short window to fire its POST
      await sleep(300); // 300–500ms is plenty in practice

      // 4) Redirect
      navigate("/login", { replace: true });
    } catch (e) {
      // Even if something odd happens, still push to login
      console.error("Logout flow error:", e);
      navigate("/login", { replace: true });
    }
  };

  // ✅ Restore user on refresh
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
      const u = localStorage.getItem("user");
      if (u) setUser(JSON.parse(u));
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, token }}>
      {children}
    </AuthContext.Provider>
  );
};
